import $ from 'jquery'

let SiteHeader = {
  Initalised : false,
  
}

SiteHeader.init = function()
{
  if(!this.Initalised)
  {
    this.Initalised = true;
  }else{
    return false;
  }

  $('#mobile-nav-bar-menu').on('click', function(event){
    if($('#mobile-nav-bar-menu-dropdown').css('display') == 'block'){
      $('#mobile-nav-bar-menu-dropdown').slideUp('fast');
      $('#mobile-nav-bar-menu-icon').removeClass('fa-times');
      $('#mobile-nav-bar-menu-icon').addClass('fa-bars');
    }else{  
      $('#mobile-nav-bar-menu-dropdown').slideDown('fast');
      $('#mobile-nav-bar-menu-icon').removeClass('fa-bars');
      $('#mobile-nav-bar-menu-icon').addClass('fa-times');
    }
    
  });

  console.log("site header");
}

SiteHeader.mobileDropdown = function()
{
 
}
export default SiteHeader;


// WEBPACK FOOTER //
// ./resources/assets/js/components/header.js